import React, { ReactNode } from 'react';
import BetterReactSlick from 'better-react-slick';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { NavigationButton } from './NavigationButton';

type Props = {
  children: ReactNode;
  settings?: Partial<{
    prevArrow: ReactNode;
    nextArrow: ReactNode;
    dots: boolean;
    infinite: boolean;
    slidesToShow: number;
    slidesToScroll: number;
  }>;
  className?: string;
};

const defaultSettings: Props['settings'] = {
  prevArrow: <NavigationButton classes="previous" ariaLabel="previous" />,
  nextArrow: <NavigationButton classes="next" ariaLabel="next" />,
  dots: false,
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 6,
};

export const Slider = (props: Props) => {
  const { children, className, settings } = props;
  const slickSettings = { ...defaultSettings, ...settings };

  return (
    <div className={cx('row container', className)}>
      <SliderWrapper className="slider">
        <BetterReactSlick {...slickSettings}>{children}</BetterReactSlick>
      </SliderWrapper>
    </div>
  );
};

const SliderWrapper = styled.div`
  .previous {
    right: 30;
  }

  .next {
    right: 0;
  }

  .slick-next,
  .slick-prev {
    background-color: ${(props) => props.theme.primary6};

    :hover {
      background-color: ${(props) => props.theme.primary3};
    }
  }

  .slick-disabled {
    background-color: ${(props) => props.theme.primary3};
  }
`;
